// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + ({"1671": "js-legacy","8626": "head-common","878": "stage_automation_icon","9474": "vendor",}[chunkId] || chunkId) + "-" + {"1671": "10c34639580c807e","3640": "219a74f2b869dcb2","4276": "41e0ab655dfadf24","8476": "92aa827e5c9630a8","8626": "6bf694c198a89b50","878": "c7ee4d71a25fdc55","8944": "919e582cfe107b79","9384": "d6ff5d2a99bb7acc","9474": "70b31ded6da13e76",}[chunkId] + ".js"
}